import { Text } from "@otrium/atoms";
import { FC } from "react";
import { GoodOnYouPillarNames } from "src/molecules/GoodOnYou/types";
import {
  StyledPillar,
  IconWrapper,
} from "src/molecules/GoodOnYou/GoodOnYou.styled";
import { useLingui } from "@lingui/react";
import { goodOnYouPillarNamesTranslation } from "src/translations/goodOnYouPillarNamesTranslation";
import ProgressBar from "./ProgressBar"; // Import the new ProgressBar component

interface Props {
  name: GoodOnYouPillarNames;
  score: number;
  icon: JSX.Element;
}

const Pillar: FC<Props> = ({ name, score, icon }) => {
  const { _ } = useLingui();
  return (
    <StyledPillar>
      <IconWrapper>{icon}</IconWrapper>
      <Text
        variant="body.source.regular14"
        as="span"
        sx={{ minWidth: "fit-content" }}
      >
        {_(goodOnYouPillarNamesTranslation[name])}
      </Text>
      <ProgressBar value={score} max={5} />
      <Text
        variant="body.source.regular12"
        as="span"
        sx={{ minWidth: "fit-content" }}
      >
        {score}/5
      </Text>
    </StyledPillar>
  );
};

export default Pillar;
